export default {"src":"/_next/static/media/ToothSensitivity.6ffae325.svg","height":75,"width":75,"blurWidth":0,"blurHeight":0};